import { jsx, Fragment } from "react/jsx-runtime";
function SafeFragment(props) {
  return /* @__PURE__ */ jsx(Fragment, { children: props.children });
}
export {
  SafeFragment
};
//# sourceMappingURL=SafeFragment.js.map
